// extracted by mini-css-extract-plugin
export default {"root":"Layout_root__NAu5Y","content":"Layout_content__tKgR-"};